import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../components/Header/parts/Title';
import { IS_BROWSER } from '../../utils/functions';

const HeroReviews = ({ input }) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (IS_BROWSER && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <>
      <Title
        title={input.primary.title.html}
        subtitle={input.primary.subtitle.html}
        description={input.primary.description.html}
        title_align={input.primary.align_text}
        //background_color={input.primary.background_color}
      />

      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-US"
        data-businessunit-id="5a612cfaf6d31d0001923488"
        data-style-height={
          input.primary.height ? input.primary.height + 'px' : '280px'
        }
        data-style-width="100%"
        data-theme="dark"
        data-stars="4,5"
        data-template-id={(() => {
          switch (input.primary.layout) {
            case 'Horizontal':
              return '5406e65db0d04a09e042d5fc';
            case 'Slider':
              return '54ad5defc6454f065c28af8b';
            case 'Grid':
            default:
              return '539adbd6dec7e10e686debee';
          }
        })()}
      >
        <a
          href="https://www.trustpilot.com/review/visualsbyimpulse.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Trustpilot
        </a>{' '}
      </div>
    </>
  );
};

HeroReviews.propTypes = {
  input: PropTypes.object.isRequired,
};

export default HeroReviews;
